<template>
  <fragment>
    <div
        v-if="item.descriptionAbove.length"
        class="font-weight-bold mt-3 mb-0 syllabus-description-typography"
        v-html="item.descriptionAbove">
    </div>
    <slot/>
    <div
        v-if="item.descriptionUnder.length"
        class="font-weight-bold mt-3 mb-0 syllabus-description-typography"
        v-html="item.descriptionUnder">
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'SectionContent',
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .syllabus-description-typography {
  font-family: inherit !important;
  font-size: inherit !important;
  line-height: inherit !important;

  p,
  div,
  span,
  ol,
  ul,
  li {
    font-family: inherit !important;
    font-size: inherit !important;
    line-height: inherit !important;
  }

  p {
    margin-bottom: 0;
  }

  ol,
  ul {
    margin-bottom: 0;
  }

  li {
    margin-bottom: 0;
  }
}
</style>
